import Highcharts from "highcharts"
import solidGauge from "highcharts/modules/solid-gauge"
import highChartsMode from "highcharts/highcharts-more"

highChartsMode(Highcharts)
solidGauge(Highcharts)

// Highcharts accessibility module is not loaded to avoid null reference errors
// (e.g. highlightFirstValidPoint when chart is unmounted/hidden). Custom SR-only
// text and data tables are used instead (see PerformanceChart, etc.).
